export const SET_BACKEND_PAYMENT_METHODS = 'SET_BACKEND_PAYMENT_METHODS'
